import { render, staticRenderFns } from "./leader-list.vue?vue&type=template&id=b97e8b88"
import script from "./leader-list.vue?vue&type=script&lang=js"
export * from "./leader-list.vue?vue&type=script&lang=js"
import style0 from "./leader-list.vue?vue&type=style&index=0&id=b97e8b88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports